import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "../consent.js";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => getConsent() === null);

  useEffect(() => {
    const onReset = () => setVisible(true);
    window.addEventListener("prawly:consent-reset", onReset);
    return () => window.removeEventListener("prawly:consent-reset", onReset);
  }, []);

  if (!visible) return null;

  const choose = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div className="cookie-banner" role="dialog" aria-label="Zgoda na cookies">
      {/* Dymek w lewym dolnym rogu; na telefonie krótsza wersja tekstu, żeby
          nie zasłaniać CTA w hero. */}
      <p className="cookie-banner-full">
        Niezbędne pliki cookies (logowanie) działają zawsze. Za Twoją zgodą używamy też
        Google Ads, TikTok Ads i Contentsquare do pomiaru skuteczności i analizy ruchu —
        możesz się na to zgodzić albo odmówić, a decyzję zmienisz w każdej chwili w stopce
        strony. Więcej w{" "}
        <Link to="/polityka-prywatnosci" target="_blank" rel="noreferrer">
          Polityce prywatności
        </Link>
        .
      </p>
      <p className="cookie-banner-short">
        Używamy niezbędnych cookies oraz — za Twoją zgodą — Google Ads, TikTok Ads i
        Contentsquare.{" "}
        <Link to="/polityka-prywatnosci" target="_blank" rel="noreferrer">
          Polityka prywatności
        </Link>
        .
      </p>
      <div className="cluster">
        <button type="button" className="btn ghost" onClick={() => choose(false)}>
          Odrzuć
        </button>
        <button type="button" className="btn wax" onClick={() => choose(true)}>
          Akceptuję
        </button>
      </div>
    </div>
  );
}
